import React from 'react';
import { MaxWidth, MinWidth, Container } from '../../common/base';
import HeaderDesktop from './HeaderDesktop';
import HeaderMobile from './HeaderMobile';
import { useTranslation } from 'react-i18next';
import { css } from 'styled-components';
import useAuth from '../../user/utils/auth/useAuth';

const HORIZONTAL_MENUS = t => [
  // {
  //   label: t('menu.idrtb_minigame', 'IDRTB Minigame'),
  //   link: '/minigame',
  //   new: true
  // },
  {
    label: t('menu.home', 'Home'),
    link: '/'
  },
  {
    label: t('landing.reports.title', 'Whitepaper'),
    link: '/#reports'
  },
  {
    label: t('menu.about', 'Our Team'),
    link: '/about'
  },
  {
    label: t('menu.faq', 'FAQ'),
    link: t('menu.faq.link', 'https://rupiahtoken.zendesk.com/hc/en-us')
  },
  {
    label: t('menu.blog', 'Blog'),
    link: t('menu.blog.link', 'https://medium.com/rupiahtoken-blog')
  }
];

const AUTH_HORIZONTAL_MENUS = t => [
  // {
  //   label: t('menu.idrtb_minigame', 'IDRTB Minigame'),
  //   link: '/minigame',
  //   new: true
  // },
  {
    label: t('menu.dashboard', 'Dashboard'),
    link: '/dashboard'
  },
  {
    label: t('landing.reports.title', 'Whitepaper'),
    link: '/#reports'
  },
  {
    label: t('menu.about', 'Our Team'),
    link: '/about'
  },
  {
    label: t('menu.faq', 'FAQ'),
    link: t('menu.faq.link', 'https://rupiahtoken.zendesk.com/hc/en-us')
  },
  {
    label: t('menu.blog', 'Blog'),
    link: t('menu.blog.link', 'https://medium.com/rupiahtoken-blog')
  }
];

const AUTH_MENUS = t => [
  {
    label: t('menu.bank_accounts', 'Bank accounts'),
    link: '/dashboard/banks'
  }
];

export default function Header({ headerType = '', ...rest }) {
  const { t } = useTranslation();
  const { isLoggedIn } = useAuth();
  const menus = isLoggedIn ? AUTH_HORIZONTAL_MENUS(t) : HORIZONTAL_MENUS(t);
  const authMenus = AUTH_MENUS(t);
  return (
    <div
      css={css`
      ${MaxWidth.md`
        border: 1px solid ${({ theme: { colors } }) => colors.dark.light};
      `}
        ${headerType === 'red' &&
          css`
            background-color: ${({ theme: { colors } }) => colors.primary.light};
            ${MaxWidth.md`
              border-color: ${({ theme: { colors } }) => colors.primary.light};
            `}
          `}

        ${headerType === 'grey' &&
          css`
            background-color: ${({ theme: { colors } }) => colors.gray.light};
            ${MaxWidth.md`
            border-color: ${({ theme: { colors } }) => colors.gray.light};`}
          `}
      `}
    >
      <div
        css={MaxWidth.md`
        display: none;
      `}
      >
        <Container>
          <HeaderDesktop menus={menus} authMenus={authMenus} {...rest} />
        </Container>
      </div>
      <div
        css={`
          ${MinWidth.md`
            display: none;
          `}
        `}
      >
        <Container>
          <HeaderMobile menus={menus} authMenus={authMenus} {...rest} />
        </Container>
      </div>
    </div>
  );
}
